import React, { useState } from "react";

export default function SenderProfilesManager({ profiles = [], permissions = [], onReload }) {
  const [emailFrom, setEmailFrom] = useState("");
  const [fromName, setFromName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [extraName, setExtraName] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [permProfileId, setPermProfileId] = useState("");
  const [permAdminId, setPermAdminId] = useState("");
  const [canSend, setCanSend] = useState(true);
  const [canView, setCanView] = useState(true);
  const [canManage, setCanManage] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");

  const createProfile = async (e) => {
    e.preventDefault();
    setError(""); setOk("");
    try {
      const res = await fetch("/api/admin/email/sender-profiles", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email_from: emailFrom, from_name: fromName, display_name: displayName, extra_name: extraName, is_default: isDefault, is_active: true }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { setError(data.error || "Не удалось создать профиль"); return; }
      setOk("Профиль создан");
      setEmailFrom(""); setFromName(""); setDisplayName(""); setExtraName(""); setIsDefault(false);
      onReload?.();
    } catch { setError("Сетевая ошибка"); }
  };

  const savePermission = async (e) => {
    e.preventDefault();
    setError(""); setOk("");
    if (!permProfileId || !permAdminId) { setError("Укажите profile_id и admin_user_id"); return; }
    try {
      const res = await fetch("/api/admin/email/sender-profiles/permissions", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ profile_id: Number(permProfileId), admin_user_id: Number(permAdminId), can_send: canSend, can_view: canView, can_manage: canManage }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) { setError(data.error || "Не удалось сохранить права"); return; }
      setOk("Права обновлены");
      setPermProfileId(""); setPermAdminId(""); setCanSend(true); setCanView(true); setCanManage(false);
      onReload?.();
    } catch { setError("Сетевая ошибка"); }
  };

  const fillPermForm = (p) => {
    setPermProfileId(String(p.sender_profile_id));
    setPermAdminId(String(p.admin_user_id));
    setCanSend(!!p.can_send); setCanView(!!p.can_view); setCanManage(!!p.can_manage);
    setOk(""); setError("");
  };

  return (
    <div style={{ marginTop: 12 }}>
      <h3>Профили отправителей</h3>
      {error && <p style={{ color: "#b91c1c" }}>{error}</p>}
      {ok && <p style={{ color: "#166534" }}>{ok}</p>}

      <div style={{ border: "1px solid #e5e7eb", padding: 10, borderRadius: 8 }}>
        <h4 style={{ marginTop: 0 }}>Доступные профили</h4>
        {profiles.length === 0 ? (
          <p style={{ color: "#6b7280" }}>Профилей нет</p>
        ) : (
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13 }}>
            <thead>
              <tr style={{ background: "#f3f4f6" }}>
                <th style={th}>ID</th><th style={th}>email_from</th><th style={th}>from_name</th>
                <th style={th}>display_name</th><th style={th}>domain</th><th style={th}>default</th><th style={th}>active</th>
              </tr>
            </thead>
            <tbody>
              {profiles.map((p) => (
                <tr key={p.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                  <td style={td}>#{p.id}</td>
                  <td style={td}>{p.email_from}</td>
                  <td style={td}>{p.from_name}</td>
                  <td style={td}>{p.display_name || "—"}</td>
                  <td style={td}>{p.domain_name || "—"}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.is_default ? "✅" : ""}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.is_active ? "✅" : "❌"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <form onSubmit={createProfile} style={{ border: "1px solid #e5e7eb", padding: 10, borderRadius: 8, marginTop: 10 }}>
        <h4 style={{ marginTop: 0 }}>Создать профиль</h4>
        <input placeholder="email_from *" value={emailFrom} onChange={(e) => setEmailFrom(e.target.value)} style={{ marginRight: 6 }} />
        <input placeholder="from_name *" value={fromName} onChange={(e) => setFromName(e.target.value)} style={{ marginRight: 6 }} />
        <input placeholder="display_name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} style={{ marginRight: 6 }} />
        <input placeholder="extra_name" value={extraName} onChange={(e) => setExtraName(e.target.value)} style={{ marginRight: 6 }} />
        <label style={{ marginRight: 8 }}><input type="checkbox" checked={isDefault} onChange={(e) => setIsDefault(e.target.checked)} /> default</label>
        <button type="submit">Создать</button>
      </form>

      <div style={{ border: "1px solid #e5e7eb", padding: 10, borderRadius: 8, marginTop: 10 }}>
        <h4 style={{ marginTop: 0 }}>Матрица прав</h4>
        {permissions.length === 0 ? (
          <p style={{ color: "#6b7280" }}>Прав не настроено</p>
        ) : (
          <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 13, marginBottom: 10 }}>
            <thead>
              <tr style={{ background: "#f3f4f6" }}>
                <th style={th}>Профиль</th><th style={th}>Админ</th>
                <th style={th}>can_send</th><th style={th}>can_view</th><th style={th}>can_manage</th><th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {permissions.map((p) => (
                <tr key={p.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                  <td style={td}>#{p.sender_profile_id} {p.email_from || ""}</td>
                  <td style={td}>#{p.admin_user_id} {p.admin_login || ""}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.can_send ? "✅" : "❌"}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.can_view ? "✅" : "❌"}</td>
                  <td style={{ ...td, textAlign: "center" }}>{p.can_manage ? "✅" : "❌"}</td>
                  <td style={td}><button onClick={() => fillPermForm(p)} style={{ fontSize: 12, padding: "2px 6px" }}>Изменить</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <form onSubmit={savePermission}>
          <h5 style={{ marginTop: 8, marginBottom: 6 }}>
            {permProfileId && permAdminId ? `Редактирование: профиль #${permProfileId}, админ #${permAdminId}` : "Добавить право"}
          </h5>
          <input placeholder="profile_id *" value={permProfileId} onChange={(e) => setPermProfileId(e.target.value)} style={{ width: 90, marginRight: 6 }} />
          <input placeholder="admin_user_id *" value={permAdminId} onChange={(e) => setPermAdminId(e.target.value)} style={{ width: 110, marginRight: 6 }} />
          <label style={{ marginRight: 8 }}><input type="checkbox" checked={canSend} onChange={(e) => setCanSend(e.target.checked)} /> can_send</label>
          <label style={{ marginRight: 8 }}><input type="checkbox" checked={canView} onChange={(e) => setCanView(e.target.checked)} /> can_view</label>
          <label style={{ marginRight: 8 }}><input type="checkbox" checked={canManage} onChange={(e) => setCanManage(e.target.checked)} /> can_manage</label>
          <button type="submit">Сохранить</button>
        </form>
      </div>
    </div>
  );
}

const th = { padding: "6px 8px", textAlign: "left", fontWeight: 600, borderBottom: "2px solid #e5e7eb" };
const td = { padding: "5px 8px" };
